import { useGetWorkOrderSerialization } from "../hooks";

export const BarcodeDimensions = [
  `1" x 2.25"`,
  `1" x 2.625"`,
  `1.25" x 2.25"`,
  `1" x 2"`,
  `0.5" x 2"`,
  `1" x 1.5"`,
  `1" x 2.833"`,
  `2.25" x 2.25"`,
  `2" x 4"`,
]?.map((label, id) => ({ id: id + 1, label }));

export const getBarcodeSize = (id = 1) => {
  const size =
    BarcodeDimensions.find((b) => b.id === id) || BarcodeDimensions[0];
  const label = size?.label;
  const [height, width] = label.replace(/[^\d.x]/g, "").split("x");

  return {
    height: `${height}in`,
    width: `${width}in`,
    maxHeight: `${height}in`,
    maxWidth: `${width}in`,
  };
};

export const Data_Object_Keys = [
  { id: 1, label: "Quantity", key: "quantity" },
  { id: 2, label: "Trees", key: "trees" },
  { id: 3, label: "Clusters", key: "clusters" },
  { id: 4, label: "Packages", key: "packages" },
  { id: 5, label: "Custom" },
];

export const Data_Objects = [
  { id: 1, label: "Work Orders", useDataHook: useGetWorkOrderSerialization },
  // {
  //   id: 2,
  //   label: "Purchase Orders",
  //   useDataHook: useGetWorkOrderSerialization,
  // },
  // { id: 3, label: "Customers", useDataHook: useGetWorkOrderSerialization },
  // { id: 4, label: "Employees", useDataHook: useGetWorkOrderSerialization },
  // { id: 5, label: "Shipments", useDataHook: useGetWorkOrderSerialization },
];

export const getDataObject = (id, dataId) => {
  const data = Data_Objects.find((d) => d.id === id) || Data_Objects[0];
  const request = data.useDataHook(dataId);
  return request;
};

export const getDataObjectKey = (id) => {
  const data = Data_Object_Keys.find((d) => d.id === id);
  return data || Data_Object_Keys[0];
};

export const Data_Object_Types = {
  WORK_ORDERS: 1,
  ORDERS: 2,
  CUSTOMERS: 3,
  EMPLOYEES: 4,
  SHIPMENTS: 5,
};

export const BarcodeFormats = [
  { id: "PDF417", label: "PDF417" },
  { id: "CODE39", label: "CODE 39" },
  { id: "CODE128", label: "CODE 128" },
  { id: "CODE128A", label: "CODE 128A" },
  { id: "CODE128B", label: "CODE 128B" },
  { id: "CODE128C", label: "CODE 128C" },
  { id: "EAN13", label: "EAN-13" },
  { id: "EAN8", label: "EAN-8" },
  { id: "UPC", label: "UPC (Universal Product Code)" },
  { id: "ITF14", label: "ITF-14" },
  { id: "MSI", label: "MSI (Modified Plessey)" },
  { id: "MSI10", label: "MSI + Mod10 Check Digit" },
  { id: "MSI11", label: "MSI + Mod11 Check Digit" },
  { id: "MSI1010", label: "MSI + Mod10 & Mod10" },
  { id: "MSI1110", label: "MSI + Mod11 & Mod10" },
  { id: "pharmacode", label: "Pharmacode" },
  { id: "codabar", label: "Codabar" },
];
